import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from '@mui/material';

import { getIconButtonSx } from './IconButton.style';

export type AdditionalIconButtonProps = {
  displayStyle: IconButtonDisplayStyle;
};

export type IconButtonDisplayStyle = 'orange' | 'blue' | 'grey' | 'red';

type IconButtonProps = MuiIconButtonProps & AdditionalIconButtonProps;

export const IconButton = ({ displayStyle, children, ...props }: IconButtonProps) => {
  const iconButtonSx = getIconButtonSx({ displayStyle });
  return (
    <MuiIconButton sx={iconButtonSx} {...props}>
      {children}
    </MuiIconButton>
  );
};
